import { Box, IconButton, SxProps, Theme } from '@mui/material'
import { DuplicateIcon } from '@sitoo/mui-components'
import { useSnackbar } from 'notistack'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  code: string
  variant?: 'dark' | 'light'
  sx?: SxProps<Theme>
}

export const CodeBlock = (props: Props) => {
  const { code, variant = 'dark', sx } = props
  const { t } = useTranslation(['shared'])
  const { enqueueSnackbar } = useSnackbar()

  const copyCode = useCallback(() => {
    void navigator.clipboard
      .writeText(code)
      .then(() => enqueueSnackbar(t('shared:copied_to_clipboard')))
  }, [code, enqueueSnackbar, t])

  const isDark = variant === 'dark'

  return (
    <Box
      sx={{
        p: 2,
        bgcolor: (theme) =>
          isDark ? theme.palette.darkBlue : theme.palette.background.page,
        fontSize: '12px',
        fontFamily: "'Roboto Mono', monospace",
        position: 'relative',
        overflow: 'hidden',
        color: (theme) =>
          isDark ? theme.palette.white : theme.palette.text.primary,
        ...sx,
      }}
    >
      <IconButton
        sx={{
          position: 'absolute',
          right: (theme) => theme.spacing(1),
          top: (theme) => theme.spacing(1),
          color: (theme) =>
            isDark ? theme.palette.white : theme.palette.text.primary,
        }}
        onClick={copyCode}
      >
        <DuplicateIcon />
      </IconButton>
      <Box component="code" sx={{ whiteSpace: 'pre-wrap' }}>
        {code}
      </Box>
    </Box>
  )
}
